export default {
    lang: {
        name: 'Play Duration'
    }
}